import * as React from "react";

import { cn } from "./Constants";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, onChange, ...props }, ref) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const combinedRef = (ref as any) || textareaRef;

  const adjustHeight = () => {
    const textarea = combinedRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight + 24}px`;
    }
  };

  React.useEffect(() => {
    adjustHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    adjustHeight();
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <textarea
      className={cn(
        "mt-2 flex min-h-20 w-full rounded-md border border-custom-border-default bg-background px-3 py-2 pb-6 ring-primary_1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary_1 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-primary_1 placeholder:text-primary_1/50 overflow-y-auto resize-none",
        className
      )}
      ref={combinedRef}
      onChange={handleChange}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
